
import { Profile } from '@brg/api';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { getCurrentAppName, getCurrentContextName } from "supporting";

export const getExpertTags = (arr: any) => {
  const result: string[] = [];

  arr?.forEach((i: any) => {
    i?.tagIds?.forEach((p: any) => result.push(p))
  })
  return result;
}


export const isExpert = (profile?: Profile, tagsIds?: string[]) => {
    //@ts-ignore
    if (profile && profile?.tagsExpert && !!profile?.tagsExpert?.length && tagsIds?.length) {
      
      //@ts-ignore
      const [ expertSign ] = profile?.tagsExpert?.filter(
        (i: any) => tagsIds?.some((f) => i?.tagIds?.includes(f))
      )
  
      if (!expertSign) {
        return false
      }
      

      return !!expertSign
    }
  
    return false
}
  
export const isTagExpert = (profile?: Profile, tagId?: string) => {
    //@ts-ignore
    if (profile && profile?.tagsExpert && profile?.tagsExpert?.length) {

        //@ts-ignore
        const [ expertSign ] = profile?.tagsExpert?.filter(
          (i: any) => i?.tagIds?.includes(tagId)
        )

        if (!expertSign) {
          return false;
        }

        return !!expertSign;
    }

    return false;
}

export const HasTagExpertPolicy = (profile?: Profile) => {
  return profile &&
    profile.rolesList &&
    Array.isArray(profile.rolesList) &&
    profile.rolesList.some(x => x.startsWith(HsePolicies.tag_expert_prefix));
}

export const ExpertsTagIdsByPolicy = (profile?: Profile) => {
  if (!profile) {
    return [];
  }

  return profile.rolesList
    .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
    .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
    .map(x => x.split('_')?.at(0))
    ?? [];
}

export const isExpertByPolicy = (profile?: Profile, tagsIds?: string[]): boolean => {
    const hasTagExpertPolicy =  profile && profile.rolesList && Array.isArray(profile.rolesList)
      && profile.rolesList.some(x => x.startsWith(HsePolicies.tag_expert_prefix));

    if (profile && hasTagExpertPolicy && tagsIds?.length) {
  
      const tagsExpert = profile.rolesList
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_'));

      if (!tagsExpert.length) {
          return false
      }

      const d = tagsExpert.find((i) => tagsIds?.includes(i[0]));
      if (!d?.length) {
        return false
      }
  
      const expert = !!d?.length;
   
      return expert
    }
  
    return false
}

export const isTagExpertByPolicy = (profile?: Profile, tagId?: string) => {
    if (!HasTagExpertPolicy(profile)) {
      return false;
    }

    if (profile && !!tagId) {
        const tagsExpert = profile.rolesList
          .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}${tagId}`))
          .map(x => x.replace(`${HsePolicies.tag_expert_prefix}${tagId}_`, ''));         

        if (!tagsExpert.length) {
            return false;
        }

        return true;
    }

    return false;
}

export const HasTagModerPolicy = (profile?: Profile) => {
  return profile &&
    profile.rolesList &&
    Array.isArray(profile.rolesList) &&
    profile.rolesList.some(x => x.startsWith(HsePolicies.tag_ordinal_prefix));
}

export const ModeratedTagsByPolicy = (profile?: Profile) => {
  if (!profile) {
    return [];
  }

  return profile.rolesList
    .filter(x => x.startsWith(`${HsePolicies.tag_ordinal_prefix}`))
    .map(x => x.replace(`${HsePolicies.tag_ordinal_prefix}`, ''))
    .map(x => x.split('_')?.at(0))
    ?? [];
}

export const isTagModerByPolicy = (profile?: Profile, tagId?: string) => {
  if (!profile || !tagId) {
    return false;
  }

  if (!HasTagModerPolicy(profile)) {
    return false;
  }

  const moderatedTagsByPolicy = ModeratedTagsByPolicy(profile);

  return moderatedTagsByPolicy?.includes(tagId);
}
import { Profile } from '@brg/api';
import { HsePolicies } from 'shared/constants/HsePolicies';
import { getCurrentAppName, getCurrentContextName } from "supporting";

export const getExpertTags = (arr: any) => {
  const result: string[] = [];

  arr?.forEach((i: any) => {
    i?.tagIds?.forEach((p: any) => result.push(p))
  })
  return result;
}


export const isExpert = (profile?: Profile, tagsIds?: string[]) => {
    //@ts-ignore
    if (profile && profile?.tagsExpert && !!profile?.tagsExpert?.length && tagsIds?.length) {
      
      //@ts-ignore
      const [ expertSign ] = profile?.tagsExpert?.filter(
        (i: any) => tagsIds?.some((f) => i?.tagIds?.includes(f))
      )
  
      if (!expertSign) {
        return false
      }
      

      return !!expertSign
    }
  
    return false
}
  
export const isTagExpert = (profile?: Profile, tagId?: string) => {
    //@ts-ignore
    if (profile && profile?.tagsExpert && profile?.tagsExpert?.length) {

        //@ts-ignore
        const [ expertSign ] = profile?.tagsExpert?.filter(
          (i: any) => i?.tagIds?.includes(tagId)
        )

        if (!expertSign) {
          return false;
        }

        return !!expertSign;
    }

    return false;
}

export const HasTagExpertPolicy = (profile?: Profile) => {
  return profile &&
    profile.rolesList &&
    Array.isArray(profile.rolesList) &&
    profile.rolesList.some(x => x.startsWith(HsePolicies.tag_expert_prefix));
}

export const ExpertsTagIdsByPolicy = (profile?: Profile) => {
  if (!profile) {
    return [];
  }

  return profile.rolesList
    .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
    .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
    .map(x => x.split('_')?.at(0))
    ?? [];
}

export const isExpertByPolicy = (profile?: Profile, tagsIds?: string[]): boolean => {
    const hasTagExpertPolicy =  profile && profile.rolesList && Array.isArray(profile.rolesList)
      && profile.rolesList.some(x => x.startsWith(HsePolicies.tag_expert_prefix));

    if (profile && hasTagExpertPolicy && tagsIds?.length) {
  
      const tagsExpert = profile.rolesList
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_'));

      if (!tagsExpert.length) {
          return false
      }

      const d = tagsExpert.find((i) => tagsIds?.includes(i[0]));
      if (!d?.length) {
        return false
      }
  
      const expert = !!d?.length;
   
      return expert
    }
  
    return false
}

export const isTagExpertByPolicy = (profile?: Profile, tagId?: string) => {
    if (!HasTagExpertPolicy(profile)) {
      return false;
    }

    if (profile && !!tagId) {
        const tagsExpert = profile.rolesList
          .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}${tagId}`))
          .map(x => x.replace(`${HsePolicies.tag_expert_prefix}${tagId}_`, ''));         

        if (!tagsExpert.length) {
            return false;
        }

        return true;
    }

    return false;
}

export const HasTagModerPolicy = (profile?: Profile) => {
  return profile &&
    profile.rolesList &&
    Array.isArray(profile.rolesList) &&
    profile.rolesList.some(x => x.startsWith(HsePolicies.tag_ordinal_prefix));
}

export const ModeratedTagsByPolicy = (profile?: Profile) => {
  if (!profile) {
    return [];
  }

  return profile.rolesList
    .filter(x => x.startsWith(`${HsePolicies.tag_ordinal_prefix}`))
    .map(x => x.replace(`${HsePolicies.tag_ordinal_prefix}`, ''))
    .map(x => x.split('_')?.at(0))
    ?? [];
}

export const isTagModerByPolicy = (profile?: Profile, tagId?: string) => {
  if (!profile || !tagId) {
    return false;
  }

  if (!HasTagModerPolicy(profile)) {
    return false;
  }

  const moderatedTagsByPolicy = ModeratedTagsByPolicy(profile);

  return moderatedTagsByPolicy?.includes(tagId);
}